import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from 'src/app/core/services/base-api.service';

@Injectable({
  providedIn: 'root'
})

export class MarketingBannerService {
  constructor(private http: HttpClient, private baseApiService: BaseApiService) { }

  getMarketingBanners(): Observable<[]> {
    const apiUrl = '/customer_object/marketing_banners';
    const marketing_banners = this.http.get<[]>(this.baseApiService.API_URL + apiUrl, {});
    return marketing_banners;
  }
}